import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { CustomerListResponse } from '../../../types/api';

export interface CustomerListFilters {
  search?: string;
  page: number;
  include_deleted?: boolean;
}

export function useCustomerList(filters: CustomerListFilters) {
  return useQuery({
    queryKey: queryKeys.customers.list(filters as unknown as Record<string, unknown>),
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filters.search) params.set('search', filters.search);
      params.set('page', String(filters.page));
      if (filters.include_deleted) params.set('include_deleted', 'true');
      const res = await apiClient.get<CustomerListResponse>(
        `${endpoints.customers.list}?${params.toString()}`,
      );
      return res.data;
    },
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
